// firebase
import { db } from "config/firebase";
import { doc, setDoc, onSnapshot } from "firebase/firestore";
import { getStorage, ref, uploadBytes } from "firebase/storage";

// SafeTwin
import { genRndString } from "SafeTwin/crypto/cryptolibsodium";

// A ---------------------------------------------------------------------- M

const uploadFile = async (fileByteArray, fileName, fileType, tagID, isPublic = false, user) => {
  return new Promise(async (resolve, reject) => {
    try {
      const uploadID = genRndString(32);
      console.log("uploadID:", uploadID);

      const storage = getStorage();
      const storageRef = ref(storage, `${uploadID}/${fileName}`);
      const statusRef = doc(db, "uploadStatuses", uploadID);

      await setDoc(statusRef, {
        createdBy: user.uid,
        createdByEmail: user.email,
        totalCount: 1,
        validCount: 0,
        invalidCount: 0,
        status: "processing",
      });

      // prettier-ignore
      const metadata = {
        contentType: fileType,
        customMetadata: {
          'isPublic': isPublic ? "true" : "false",
          'requiresValidation': "true",
        }
      };

      if (tagID) metadata.customMetadata["tagID"] = tagID;

      try {
        await uploadBytes(storageRef, fileByteArray, metadata);
      } catch (error) {
        console.error("Error in uploading bytes:", error);
      }

      const unsubscribe = onSnapshot(statusRef, async (doc) => {
        if (doc.exists) {
          const status = doc.data().status;
          if (status === "success") {
            unsubscribe();
            const storagePath = storageRef.fullPath;
            resolve({ uploadID, storagePath });
          } else if (status === "error") {
            unsubscribe();
            reject(new Error("Invalid file"));
          }
        }
      });
    } catch (err) {
      console.error("Error in uploadFile:", err);
      reject(err);
    }
  });
};

export default uploadFile;
